import { Pipe, PipeTransform } from "@angular/core";
import { getAwaitingApprovalProductRequestItemCount } from "../helpers/get-awaiting-approval-product-request-item-count";
import { ProductRequest } from "../models/ProductRequest";

@Pipe({name: 'awaitingApprovalProductRequestItemCount'})
export class AwaitingApprovalProductRequestItemCountPipe implements PipeTransform {
  transform(value: ProductRequest): number {
    return getAwaitingApprovalProductRequestItemCount(value);
  }
}